/**
 * SocketProvider: bootstraps the Socket.IO connection on mount.
 * The actual subscriptions happen per-feature via the `subscribe()` helper.
 *
 * Also drives the admin-presence heartbeat. As long as ANY tab of the
 * dashboard is open and visible, the server treats the admin as "online"
 * and persists incoming agent screenshots. The flag auto-clears 30s
 * after the last heartbeat or when the tab goes hidden.
 */
import { useEffect } from 'react'
import type { ReactNode } from 'react'
import { disconnectSocket, getSocket } from '@/lib/socket'
import { startPresence, stopPresence } from '@/services/admin-presence.service'

export function SocketProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    getSocket() // initialize connection
    void startPresence()
    return () => {
      void stopPresence()
      disconnectSocket()
    }
  }, [])
  return <>{children}</>
}
